export default __webpack_public_path__ + "static/media/KLIMA.5491344a.png";